import Lottie from 'lottie-react';
import { Link } from 'react-router-dom';
import invalidRequest from "../components/Common/animationJson/error-page.json";

function InvalidRequestPage() {
  return (
    <div class="py-16 px-4 md:px-6 2xl:px-20 2xl:container 2xl:mx-auto bg-white">
      <div class="flex justify-center item-center flex-col text-center">
        <div className="flex justify-center items-center">
          <Lottie animationData={invalidRequest} loop={true} animationDelay={1500} autoplay={true} className="w-48" />
        </div>
        <h1 class="text-xl lg:text-3xl font-semibold text-gray-900 capitalize">Request is not valid</h1>
        <p class="my-5 text-base text-gray-600 capitalize w-full">Unfortunately the page you are looking for has been moved or deleted</p>
        <Link to="/" className="w-40 mx-auto py-3 rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>Go To Homepage</Link>
      </div>
    </div>
  );
}

export default InvalidRequestPage;